import { Route } from '@angular/router';
import { IsAdminGuard } from '@spotter/guards/login-guard';

/** Adds the pages for data routes. */
export function addDataPageRoutes(): Route[] {
  return [
    {
      path: 'data/species/:speciesid',
      loadComponent: () => import('../pages/data/species-page/species-page.component').then(m => m.SpeciesPageComponent)
    },
    {
      path: 'data/users', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/data/users-page/users-page.component').then(m => m.UsersPageComponent)
    },
    {
      path: 'data/sightings',
      loadComponent: () => import('../pages/data/sightings-page/sightings-page.component').then(m => m.SightingsPageComponent)
    },
    {
      path: 'data/visitors', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/data/visitors-page/visitors-page.component').then(m => m.VisitorsPageComponent)
    },
    {
      path: 'data/absences',
      loadComponent: () => import('../pages/data/absences-page/absences-page.component').then(m => m.AbsencesPageComponent)
    },
    {
      path: 'data/identify-flowchart',
      loadComponent: () => import('../pages/data/identify-flow-chart/identify-flow-chart.component').then(m => m.IdentifyFlowChartComponent)
    },

    {
      path: 'data/reports/sightings',
      loadComponent: () => import('../pages/data/reports-sighting-page/reports-sighting-page.component').then(m => m.ReportsSightingPageComponent)
    },

    {
      path: 'data/monthly-report/:date',
      loadComponent: () => import('../pages/data/monthly-report/monthly-report.component').then(m => m.MonthlyReportComponent)
    },
    {
      path: 'data/monthly-report-wales/:date',
      loadComponent: () => import('../pages/data/monthly-report-wales/monthly-report-wales.component').then(m => m.MonthlyReportWalesComponent)
    },
  ];
}
